// Small building blocks shared by the sections of this page.
import React from 'react';
import { motion } from 'framer-motion';
import styles from './ScreenInspector.module.css';

export const EASE = [0.22, 1, 0.36, 1];
export const REPO_URL = 'https://gitlab.meetyuwen.com/testing/vlm-page-recognition';
export const RED = '#F43F5E';
export const BLUE = '#38BDF8';
export const PURPLE = '#C084FC';

/** Fades and lifts its children in when the slide appears. */
export function Reveal({ children, className, delay = 0, y = 24 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 + delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

/** Centered section opening: small eyebrow, big headline, one line of grey text. */
export function Intro({ eyebrow, title, sub, id }) {
    return (
        <Reveal className={styles.intro}>
            {eyebrow && <p className={styles.eyebrow} id={id}>{eyebrow}</p>}
            <h2 className={styles.headline}>{title}</h2>
            {sub && <p className={styles.sub}>{sub}</p>}
        </Reveal>
    );
}

/** Pill-style segmented control; the white pill slides between options. */
export function Segmented({ group, options, value, onChange, label, small = false }) {
    return (
        <div className={`${styles.segmented} ${small ? styles.segSmall : ''}`} role="tablist" aria-label={label}>
            {options.map((o) => {
                const active = value === o.id;
                return (
                    <button
                        key={o.id}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        className={`${styles.segBtn} ${active ? styles.segActive : ''}`}
                        onClick={() => onChange(o.id)}
                    >
                        {active && (
                            <motion.span
                                layoutId={`seg-${group}`}
                                className={styles.segPill}
                                transition={{ type: 'spring', stiffness: 400, damping: 34 }}
                            />
                        )}
                        <span className={styles.segText}>{o.label}</span>
                    </button>
                );
            })}
        </div>
    );
}

/** Read / write a per-browser preference; storage can be unavailable. */
export function readPref(key, fallback, allowed) {
    try {
        const v = window.localStorage.getItem(key);
        return allowed.includes(v) ? v : fallback;
    } catch (e) {
        return fallback;
    }
}

export function writePref(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        // private mode or blocked storage: the choice just is not remembered
    }
}
